import { createContext, useContext } from 'react';

import { Banner } from '@components/Banner/Banner';
import { AnimatePresence } from 'framer-motion';
import noop from 'lodash-es/noop';

type errorType = string | null;
export interface TabBannerContextType {
  error: errorType;
  setError: (err: errorType) => void;
}
export const UserProfileTabBannerErrorContext = createContext<TabBannerContextType>({
  error: null,
  setError: noop,
});

/**
 * Error banner which consumes the `TabBannerContext` context
 * to display under the tab menu for the user profile page.
 */
export function UserProfileErrorBanner() {
  const { error } = useContext(UserProfileTabBannerErrorContext);

  return <AnimatePresence>{error && <Banner type='error' text={error} />}</AnimatePresence>;
}
